import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';

// maintenance routing
const MaintenanceError = Loadable(lazy(() => import('views/pages/maintenance/Error')));
const MaintenanceComingSoon1 = Loadable(lazy(() => import('views/pages/maintenance/ComingSoon/ComingSoon1')));
const MaintenanceComingSoon2 = Loadable(lazy(() => import('views/pages/maintenance/ComingSoon/ComingSoon2')));
const MaintenanceUnderConstruction = Loadable(lazy(() => import('views/pages/maintenance/UnderConstruction')));

// landing & contact-us routing
const PagesHomepage = Loadable(lazy(() => import('views/pages/homepage')));
const PagesContactUS = Loadable(lazy(() => import('views/pages/contact-us')));
const PagesFaqs = Loadable(lazy(() => import('views/pages/saas-pages/Faqs')));
const PagesTermOfUse = Loadable(lazy(() => import('views/pages/saas-pages/TermOfUse')));
const PagesPrivacyPolicy = Loadable(lazy(() => import('views/pages/saas-pages/PrivacyPolicy')));
const PagesSearchResult = Loadable(lazy(() => import('views/pages/saas-pages/SearchResult')));

const BotGpt = Loadable(lazy(() => import('views/workspace/botgpt')));
// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
    path: '/',
    element: <MinimalLayout />,
    children: [

        {
            path: '/*',
            element: <MaintenanceError />
        },
        {
            path: '/pages/coming-soon1',
            element: <MaintenanceComingSoon1 />
        },
        {
            path: '/pages/coming-soon2',
            element: <MaintenanceComingSoon2 />
        },
        {
            path: '/pages/under-construction',
            element: <MaintenanceUnderConstruction />
        },

        {
            path: '/pages/homepage',
            element: <PagesHomepage />
        },
        {
            path: '/pages/contact-us',
            element: <PagesContactUS />
        },
        {
            path: '/pages/faqs',
            element: <PagesFaqs />
        },
        {
            path: '/pages/term-of-use',
            element: <PagesTermOfUse />
        },
        {
            path: '/pages/privacy-policy',
            element: <PagesPrivacyPolicy />
        },
        {
            path: '/pages/search-result',
            element: <PagesSearchResult />
        },
        {
            path: '/pages/bot',
            element: <BotGpt />
        }
    ]
};

export default AuthenticationRoutes;
